import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Grid, Dimmer, Loader, Message } from 'semantic-ui-react';
import { registerFirebase, hideMessage } from './actions';
import './App.css';
import Header from './components/Header';
import ProductMenu from './components/ProductMenu';
import ProductOfflineMenu from './components/ProductOfflineMenu';
import Products from './pages/Products';
import ProductsOffline from './pages/ProductsOffline';
// import Sales from './pages/Sales';
import Orders from './pages/Orders';
import OrderDetails from './pages/OrderDetails';
// import SalesMenu from './components/SalesMenu';
import OrderMenu from './components/OrderMenu';
import Customers from './pages/Customers';
import CustomerMenu from './components/CustomerMenu';
import Staffs from './pages/Staffs';
import StaffMenu from './components/StaffMenu';
import Misc from './pages/Misc';
import MiscMenu from './components/MiscMenu';
import Login from './pages/Login';
import PasswordReset from './pages/PasswordReset';
import VouchersMenu from './components/VouchersMenu';
import Vouchers from './pages/Vouchers';
import LoginRecordsMenu from './components/LoginRecordsMenu';
import LoginRecords from './pages/LoginRecords';
import SalesReportMenu from './components/SalesReportMenu';
import SalesReport from './pages/SalesReport';
import Holiday from './pages/Holiday';
import HolidayMenu from './components/HolidayMenu';
import Quotations from './pages/Quotations';
import QuotationDetails from './pages/QuotationDetails';
import QuotationMenu from './components/QuotationMenu';
import PaymentTerms from './pages/PaymentTerms';


const AdminRoute = ({ component: Component, user: User, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      (User && User.role === 'ADMIN') ? (
        <Component {...props} />
      ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        )
    }
  />
);

class App extends Component {

  componentWillMount() {
    this.props.registerFirebase();
  }

  handleMessageClose() {
    this.props.hideMessage();
  }

  render() {
    const { loader, message } = this.props.main;
    const { user } = this.props.auth;

    return (
      (user && user.state === 'ACTIVE')
        ?
        <Router basename="/admin">
          <div>
            <Dimmer active={loader.active}>
              <Loader size='large'>{loader.message}</Loader>
            </Dimmer>
            <Route render={props => <Header {...props} />} />
            <Grid>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Switch>
                    <Route exact path="/" component={OrderMenu} />
                    <AdminRoute path="/products/:product_name" user={user} component={ProductMenu} />
                    <AdminRoute path="/products" user={user} component={ProductMenu} />
                    <AdminRoute path="/products_offline/:product_name" user={user} component={ProductOfflineMenu} />
                    <AdminRoute path="/products_offline" user={user} component={ProductOfflineMenu} />
                    <Route path="/orders" component={OrderMenu} />
                    <Route path="/order_details" component={OrderMenu} />
                    <Route path="/sales" component={SalesReportMenu} />
                    <AdminRoute path="/misc" user={user} component={MiscMenu} />
                    <Route path="/customers" component={CustomerMenu} />
                    <Route path="/logins" component={LoginRecordsMenu} />
                    <AdminRoute path="/staffs" user={user} component={StaffMenu} />
                    <AdminRoute path="/vouchers/" user={user} component={VouchersMenu} />
                    <AdminRoute path="/holiday/" user={user} component={HolidayMenu} />
                    <Route path="/quotations/" user={user} component={QuotationMenu} />
                    <Route path="/quotation_details" component={QuotationMenu} />
                    <AdminRoute path="/payment_terms" user={user} component={MiscMenu} />
                  </Switch>
                </Grid.Column>
                <Grid.Column width={12}>
                  <div style={{ marginTop: '3em' }}>
                    <Switch>
                      <Route exact path="/" component={Orders} />
                      <AdminRoute path="/products/:product_name" user={user} component={Products} />
                      <AdminRoute path="/products" user={user} component={Products} />
                      <AdminRoute path="/products_offline/:product_name" user={user} component={ProductsOffline} />
                      <AdminRoute path="/products_offline" user={user} component={ProductsOffline} />
                      <Route path="/orders/:cat" component={Orders} />
                      <Route path="/orders" component={Orders} />
                      <Route path="/order_details/:order_id" component={OrderDetails} />
                      <Route path="/sales" component={SalesReport} />
                      <AdminRoute path="/holidays" user={user} component={Holiday} />
                      <AdminRoute path="/misc" user={user} component={Misc} />
                      <Route path="/customers" component={Customers} />
                      <Route path="/logins" component={LoginRecords} />
                      <AdminRoute path="/staffs" user={user} component={Staffs} />
                      <AdminRoute path="/vouchers" user={user} component={Vouchers} />
                      <AdminRoute path="/holiday" user={user} component={Holiday} />
                      <Route path="/quotations/:cat" user={user} component={Quotations} />
                      <Route path="/quotations" user={user} component={Quotations} />
                      <Route path="/quotation_details/:quote_id" component={QuotationDetails} />
                      <AdminRoute  path="/payment_terms" user={user} component={PaymentTerms} />

                    </Switch>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Router>
        :
        <Router basename="/admin">
          <div>
            <Dimmer active={loader.active}>
              <Loader size='large'>{loader.message}</Loader>
            </Dimmer>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/reset_password" component={PasswordReset} />
            </Switch>
          </div>
        </Router>
    );
  }
}

const mapStateToProps = ({ main, auth }) => {
  return { main, auth }
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({
    registerFirebase: registerFirebase,
    hideMessage: hideMessage,
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(App);